import { Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from '@angular/fire/firestore';
import {Observable} from 'rxjs/Observable';
import * as firebase from 'firebase';
import {RequestOfLeave} from './objects/RequestOfLeave';
import { AngularFireStorage, AngularFireUploadTask } from '@angular/fire/storage';

@Injectable()
export class DocumentService {
  private requestDoc: AngularFirestoreDocument<RequestOfLeave>;
  requestsForLeave: AngularFirestoreCollection<RequestOfLeave>;
  approvedRequests: AngularFirestoreCollection<RequestOfLeave>;
  deniedRequests: AngularFirestoreCollection<RequestOfLeave>;

  firestoreConfig = {
    collection_endpoint: 'tasks',
    approval_endpoint: 'tasksApproved',
    denial_endpoint: 'tasksDenied'
  };
  storageRef;
  private basePath = '/uploads/';
  downloadURL;
  path;

  constructor(private http: HttpClient,
              private afAuth: AngularFireAuth,
              private afs: AngularFirestore,
              private storage: AngularFireStorage) {
    this.storageRef = firebase.storage().ref();
    this.requestsForLeave = afs.collection<RequestOfLeave>(this.firestoreConfig.collection_endpoint);
    this.approvedRequests = afs.collection<RequestOfLeave>(this.firestoreConfig.approval_endpoint);
    this.deniedRequests = afs.collection<RequestOfLeave>(this.firestoreConfig.denial_endpoint);
  }

  addRequest(request) {
    this.requestsForLeave.add(request).then(data => {
      return data.id;
    }, (err) => {
      console.log('Error, request for leave could not be added to the DB: {}', err);
    });
  }

  approveRequest(request, id) {
    this.approvedRequests.add(request).then( () => {
      this.deleteTask(id);
      alert('Your request has been received! A copy of the signed request will arrive in your email. You will be contacted by phone if there is an issue.');
    }, (err) => {
      console.log('Approval unfulfilled \n' + err);
      }
    );
  }

  denyRequest(request, id) {
    this.deniedRequests.add(request).then(() => {
      this.deleteTask(id);
      alert('Request denied.');
    }, (err) => {
      console.log('Deny failed \n' + err);
      });
  }

  updateRequest(id, update) {
    this.requestDoc = this.afs.doc<RequestOfLeave>('/tasks/' + id);

    this.requestDoc.update(update);
  }

  deleteTask(id) {
    console.log('Deleting tasks/ ' + id);
    this.requestDoc = this.afs.doc<RequestOfLeave>('/tasks/' + id);
    this.requestDoc.delete().then(() => {
      console.log('Delete Complete');
    },
      (err) => {
      console.log(err + ' --Delete failed');
    });
  }

  getDoc(date) {
    window.open(this.storageRef.child(this.basePath + '/' + date).getDownloadURL().getResult());
  }
}
